import { Header } from "../Header";
import { Footer } from "../Footer";
import { Outlet, useLocation } from "react-router-dom";
import SchemaMarkup from "../SchemaMarkup";

const Layout = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  const breadcrumbs = [
    { name: "Home", item: "/" }
  ];

  let currentPath = "";
  pathSegments.forEach((segment) => {
    currentPath += `/${segment}`;
    let name = segment.replace(/-/g, " ");
    name = name.charAt(0).toUpperCase() + name.slice(1);
    breadcrumbs.push({ name, item: currentPath });
  });

  return (
    <div className="wrapper">
      <SchemaMarkup type="Breadcrumb" data={breadcrumbs} />
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};

export default Layout;
